const sixteenData = [
    { 
    sno: 1, companyName: 'TCS', 
    recruitmentDate: '07 to 11-10-2015',
    btechCSE: 10,
    btechIT: 16,
    btechECE: 23, 
    btechEEE: 9, 
    btechMECH: 7, 
    btechMET: 14, 
    btechCIVIL: '-', 
    mtechCSE: '-', 
    mtechIT: '-', 
    onOffCampus: 'On Campus', 
    totalSelections: 81 
   },

    { sno: 2, companyName: 'GLENWOOD SYSTEMS', recruitmentDate: '17-12-2015', btechCSE: '-', btechIT: '-', btechECE: '-', btechEEE: 4, btechMECH: '-', btechMET: '-', btechCIVIL: '-', mtechCSE: '-', mtechIT: '-', onOffCampus: 'Off Campus', totalSelections: 4 },
    { sno: 3, companyName: 'GREYCAMPUS', recruitmentDate: '28-12-2015', btechCSE: '-', btechIT: 2, btechECE: '-', btechEEE: 3, btechMECH: '-', btechMET: '-', btechCIVIL: '-', mtechCSE: '-', mtechIT: '-', onOffCampus: 'On Campus', totalSelections: 5 },
    { sno: 4, companyName: 'APPS ASSOCIATES', recruitmentDate: '18-12-2015', btechCSE: '-', btechIT: '-', btechECE: '-', btechEEE: 1, btechMECH: '-', btechMET: 1, btechCIVIL: '-', mtechCSE: '-', mtechIT: '-', onOffCampus: 'Off Campus', totalSelections: 2 },
    { sno: 5, companyName: 'MEDHA SERVO', recruitmentDate: '02-08-2016', btechCSE: '-', btechIT: '-', btechECE: 1, btechEEE: '-', btechMECH: '-', btechMET: '-', btechCIVIL: '-', mtechCSE: '-', mtechIT: '-', onOffCampus: 'Off Campus', totalSelections: 1 },
    { sno: 6, companyName: 'TCS', recruitmentDate: '02-03-2016', btechCSE: '-', btechIT: '-', btechECE: '-', btechEEE: 4, btechMECH: '-', btechMET: '-', btechCIVIL: '-', mtechCSE: '-', mtechIT: '-', onOffCampus: 'Off Campus', totalSelections: 4 },
    { sno: 7, companyName: 'ZEBI', recruitmentDate: '14-03-2016', btechCSE: '-', btechIT: '-', btechECE: '-', btechEEE: 1, btechMECH: '-', btechMET: '-', btechCIVIL: '-', mtechCSE: '-', mtechIT: '-', onOffCampus: 'On Campus', totalSelections: 1 },
    { sno: 8, companyName: 'CHEGG India.pvt.ltd', recruitmentDate: '29-03-2016', btechCSE: '-', btechIT: 2, btechECE: 1, btechEEE: '-', btechMECH: '-', btechMET: '-', btechCIVIL: '-', mtechCSE: '-', mtechIT: '-', onOffCampus: 'On Campus', totalSelections: 3 },
  ];
  
  export default sixteenData;
  